import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import  {cancelRectangleSelection, startRectangleSelection, setPickController}  from './region_select';
import { datareadStore, datasetStore, eventsStore, videoStore, spacecraftStore, poiStore, gmapStore, stellarStore, uiStore, appStore } from '../managers/globalState';
import globalRefs from '../managers/globalRefs';
import { useSnapshot } from 'valtio';
import { HOME_PAGE } from '../config/constants';
import '../../www/assets/css/rectangle_select_button.css';
import LoadIconSVG from '../../www/assets/images/load_icon.svg';
const RectangleSelectButton = () => {
  const { isSelectingRegion, hasSelectedRegion } = useSnapshot(datareadStore.state);
  const { currentDataset, currentVS } = useSnapshot(datasetStore.state);
  const { queries } = useSnapshot(appStore.state);
  const visibleEarthIds = ['visibleEarth', 'viirsToday', 'modisToday', 'modisAquaToday'];
  const isVisibleEarth = visibleEarthIds.includes(currentDataset?.externalId);
  const { overlayType, isDetailPanelOpen, controlsMenu } = useSnapshot(uiStore.state);
  const { currentVideo } = useSnapshot(videoStore.state);
  //const {isVisibleEarth } = useSnapshot(datasetStore.state);
  const isSatellites = currentVS?.value === 'satellites';
  
  // Determine if this is the first location in the history.
  const location = useLocation();
  const { state, pathname } = location;
  const { notFirstPage } = state ?? {};
  const hasNavigatedAwayFromHome = notFirstPage ?? pathname !== HOME_PAGE;
  const isTimelapseActive = queries?.animating === 'true';
  
  const isVisible = hasNavigatedAwayFromHome && Boolean(currentDataset) && !isVisibleEarth && !isSatellites && !currentVideo && !overlayType && !isTimelapseActive && !isDetailPanelOpen && controlsMenu !== 'settings';

  const handleClick = () => {
    if (hasSelectedRegion) {
      alert('جاري تحديد بيانات المنطقة. يُرجى الإلغاء أو تصدير البيانات أولًا.');
      return;
    }
    const newValue = !isSelectingRegion;
    datareadStore.setGlobalState({ isSelectingRegion: newValue });

    if (newValue) {
      setPickController();
      startRectangleSelection();
    } else {
      cancelRectangleSelection(); 
    }
  };
  const [showTooltip, setShowTooltip] = useState(false);
  
  const tooltipText = "لبدء التحميل: اسحب المؤشر داخل الكرة الأرضية لرسم المنطقة المطلوبة. علماً ان القيم المعروضة تمثل متوسط العلامة الحيوية المختارة داخل المربع المحدد. يمكن عرض البيانات التفصيلية بعد تصدير المنطقة المحددة.";

  return isVisible && (
  //  <button 
    //   className={`select-button ${isSelectingRegion ? 'active' : ''}`}
    //   onClick={handleClick}
    //   title="لبدء التحميل: اسحب المؤشر داخل الكرة الأرضية لرسم المنطقة المطلوبة. علماً ان القيم المعروضة تمثل متوسط العلامة الحيوية المختارة داخل المربع المحدد. يمكن عرض البيانات التفصيلية بعد تصدير المنطقة المحددة."
    //   style={{
    //     // backgroundColor: '#cc0000',
    //     // color: 'white',
    //     // border: 'none',
    //     borderRadius: '4px',
    //     //marginLeft: '214px',
    //     pointerEvents: datareadStore.state.hasSelectedRegion ? 'none' : 'auto',
    //     //padding: '8px 12px',
    //     // cursor: 'pointer'
    //   }}
    // >
    //   اختيار
    // </button>
     <div style={{ position: 'relative', display: 'inline-block' }}>
      <button 
        className={`select-button ${isSelectingRegion ? 'active' : ''}`}
        onClick={handleClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        style={{
          pointerEvents: datareadStore.state.hasSelectedRegion ? 'none' : 'auto',
          backgroundColor: '#2a5e96',
          color: '#fff',
          fontSize: '14px',
          fontWeight: 500,
          height: '32px',
          lineHeight: '20px',
          marginTop: '14px',
          padding: '0 12px',
          textTransform: 'none',
          width: '100%',
          whiteSpace: 'nowrap',
             display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // // gap: '5px',
    // backgroundColor: '#2a5e96',
    // color: '#fff',
    // fontSize: '14px',
    // fontWeight: 500,
    // height: '32px',
    // padding: '0 12px',
    // borderRadius: '6px',
    // border: 'none',
    // whiteSpace: 'nowrap',
        }}
      >
        {/* تحميل البيانات
        <LoadIconSVG  style={{ width: "17px",height: "17px" , margin: "5px" }}/> */}
          {hasSelectedRegion ? 'اختيار ': 'تحميل البيانات'}
{!hasSelectedRegion && (
  <LoadIconSVG style={{ width: "14px", height: "13px"}} />
)}  
        
      </button>
      
      {showTooltip && (
        <div 
          style={{
            position: 'absolute',
            left: '80%',
            marginBottom: '3px',
            color: '#181818',
            padding: '12px 16px',
            borderRadius: '6px',
            fontSize: '12px',
            backgroundColor: '#EEE',
            maxWidth: '320px',
            width: 'max-content',
            textAlign: 'right',
            direction: 'rtl',
            pointerEvents: 'none'
          }}
        >
          {tooltipText}
       
      
        </div>
      )}
    </div>
  );
};

export default RectangleSelectButton;
